<template>
  <el-dialog
    title="批量更新"
    :visible.sync="visible"
    width="500px"
    @close="$emit('update:show', false)"
    :close-on-click-modal="false"
  >
    <el-form ref="form" label-width="100px" :model="model" :rules="formRules">
      <el-form-item label="最终客户：" prop="install_customer_id">
        <customer-select
          v-if="visible"
          :val="model.install_customer_id"
          :filterCustomerID="filterCustomerID"
          @change="model.install_customer_id = $event"
        ></customer-select>
      </el-form-item>
      <el-form-item label="中间商：" prop="sold_customer_id">
        <customer-select
          v-if="visible"
          @change="model.sold_customer_id = $event"
        ></customer-select>
      </el-form-item>
      <el-form-item label="OEM厂商：" prop="oem_customer_id">
        <customer-select
          v-if="visible"
          @change="model.oem_customer_id = $event"
        ></customer-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submitForm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { customerDeviceBatchTransfer } from '@/service/getData'
import CustomerSelect from '@/components/select/customer_select'

export default {
  components: { CustomerSelect },
  props: {
    model: {
      type: Object,
    },
    filterCustomerID: {
      type: Number,
      default: 0,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      formRules: {
        install_customer_id: [
          { required: true, message: '最终客户不能为空', trigger: 'change' },
        ],
      },
      submiting: false,
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true
          if (!this.model.install_customer_id) {
            this.model.install_customer_id = 0
          }
          if (!this.model.sold_customer_id) {
            this.model.sold_customer_id = 0
          }
          if (!this.model.oem_customer_id) {
            this.model.oem_customer_id = 0
          }

          let res = await customerDeviceBatchTransfer(this.model)
          if (res.code == 0) {
            this.$emit('updated', res.data)
          }
          this.submiting = false
          this.visible = false
        } else {
          this.submiting = false
          return false
        }
      })
    },
  },
}
</script>